import { EventBus } from '../../event-bus';
import { listService } from '../../services/ListService';
import { orderService } from '../../services/OrderService';
import { ownerService } from '../../services/OwnerService';
import { mapGetters, mapMutations } from 'vuex';
import Multiselect from 'vue-multiselect'
import { required, requiredIf, minLength, maxLength, alphaNum } from 'vuelidate/lib/validators'
import { VueAutosuggest } from "vue-autosuggest";
import Datepicker from 'vuejs-datepicker';

const doesNotContainIorO = (value) => (value == null) || (value == undefined) || (value.indexOf('I') < 0 && value.indexOf('i') < 0 && value.indexOf('O') < 0 && value.indexOf('o') < 0);

export default {
    name: 'EditVehicle',

    components: {
        Datepicker,
        Multiselect,
        VueAutosuggest
    },

    data() {
        return {
            loading: true,
            //
            vehicle: {},
            //
            registerType: null,
            registerTypes: [], // Filled on created()
            //
            vehicleCategory: null,
            vehicleSubCategory: {},
            vehicleCategories: [], // Filled on created()
            vehicleSubCategories: [],
            //
            usageType: null,
            usageTypes: [], // Filled on created()
            //
            fuelType: null,
            fuelTypes: [], // Filled on created()
            //
            vehicleBrand: null,
            vehicleBrands: [], // Filled on created()
            //
            buildYear: {},
            buildYears: [], // Filled on created()
            //

            vehicleSuggestions: [],
            // owner vehicle list
            ownerVehicles: [],
            ownerVehiclesFields: [],

            debounceMilliseconds: 5000,
            timeout: null,


            sectionConfigs: {
                vehicles: {
                    limit: 10,
                    label: "Alege un vehicul",
                    onSelected: selected => {
                        console.log('selectHandler ' + selected.item.PlateNo);
                        this.vehicle = selected.item;

                        if (this.vehicle.LastOwner != null) {

                            var message = 'Doriti sa preluati datele ultimului proprietar ';
                            if (this.vehicle.LastOwner.OwnerType == 0) {
                                message += this.vehicle.LastOwner.Person.FirstName + ' ' + this.vehicle.LastOwner.Person.LastName + ' ?';
                            }
                            else
                                message += this.vehicle.LastOwner.Company.Name + ' ?';

                            this.$bvModal.msgBoxConfirm(message, {
                                title: 'Preluare date proprietar',
                                okVariant: 'primary',
                                okTitle: 'Da',
                                cancelTitle: 'Nu',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                            })
                                .then(value => {
                                    if (value) {
                                        if (this.vehicle.LastOwner.OwnerType == 0) {
                                            this.setPersonToOrder(this.vehicle.LastOwner.Person);
                                        }
                                        else {
                                            this.setCompanyToOrder(this.vehicle.LastOwner.Company);
                                        }

                                        // set address
                                        this.setOwnerAddress(this.vehicle.LastOwner.Address);

                                        // emit event to reload owner
                                        EventBus.$emit('ownerData_updated');
                                    }
                                })
                                .catch(err => {
                                    // An error occurred
                                })
                        }

                        this.setMultiSelectObjects();
                    }
                },
            },
            vehiclesFound: false,
            inputPropsPlateNo: null,
            inputPropsChassisNumber: null,
        }
    },

    validations: {
        vehicle: {
            PlateNo: {
                required: requiredIf(function () { return (this.registerType.Code != 2); /* Different than 'In vederea inmatricularii' */ }),
                alphaNum,
                minLength: minLength(5),
                maxLength: maxLength(50)
            },
            ChassisNumber: {
                required,
                alphaNum,
                minLength: minLength(4),
                maxLength: maxLength(17),
                doesNotContainIorO
            },
            EngineCapacity: {
                required
            },
            Power: {
                required
            },
            Seats: {
                required
            },
            Weight: {
                required
            },
            Model: {
                required
            },
            CIV: {
                required
            },
            //TechnicalExpirationDate: {
            //    required
            //},
            Mileage: {
                required
            },
            //FirstRegistrationDate: {
            //    required
            //}
        },
        registerType: {
            required
        },
        vehicleCategory: {
            required
        },
        vehicleSubCategory: {
            required
        },
        usageType: {
            required
        },
        fuelType: {
            required
        },
        vehicleBrand: {
            required
        },
        buildYear: {
            required
        },
    },

    computed: {
        ...mapGetters({
            orderEditable: 'order/orderEditable',
            orderVehicle: 'order/vehicle',
            currentOrderTypeId: 'order/currentOrderTypeId'
        }),
        //
        isValid() {
            return !this.$v.$anyError
        },
        vehiclePlateNoIsInvalid() {
            return this.$v.vehicle.PlateNo.$anyError;
        },
        vehicleChassisNumberIsInvalid() {
            return this.$v.vehicle.ChassisNumber.$anyError;
        },
        registerTypeIsInvalid() {
            return this.$v.registerType.$anyError;
        },
        vehicleCategoryIsInvalid() {
            return this.$v.vehicleCategory.$anyError;
        },
        vehicleSubCategoryIsInvalid() {
            return this.$v.vehicleSubCategory.$anyError;
        },
        usageTypeIsInvalid() {
            return this.$v.usageType.$anyError;
        },
        fuelTypeIsInvalid() {
            return this.$v.fuelType.$anyError;
        },
        //technicalExpirationDateIsInvalid() {
        //    return this.$v.vehicle.TechnicalExpirationDate.$anyError;
        //},
        //firstRegistrationDateIsInvalid() {
        //    return this.$v.vehicle.FirstRegistrationDate.$anyError;
        //},
        buildYearIsInvalid() {
            return this.$v.buildYear.$anyError;
        },
        vehicleBrandIsInvalid() {
            return this.$v.vehicleBrand.$anyError;
        },

    },

    // Fetches when the component is created.
    created() {
        EventBus.$on('owner_selected', this.ownerSelected);

        this.registerTypes = listService.getRegisterTypes();
        this.vehicleCategories = listService.getVehicleCategories();
        this.usageTypes = listService.getUsageTypes();
        this.fuelTypes = listService.getFuelTypes();
        this.vehicleBrands = listService.getVehicleBrands();
        this.buildYears = listService.getVehicleBuildYears();

        this.vehicle = JSON.parse(JSON.stringify(this.orderVehicle));

        this.setMultiSelectObjects();

        this.ownerVehiclesFields = [
            { key: 'Id', label: 'Numar de inmatriculare', sortable: true, thStyle: 'width:15%' },
            { key: 'ChassisNumber', label: 'Sasiu', sortable: true, thStyle: 'width:15%' },

        ];

        this.inputPropsPlateNo = {
            id: "vehicle__autosuggest__inputPropsPlateNo",
            placeholder: "minim 3 caractere pentru cautare",
            class: "form-control",
            autocomplete: "off", // google will not propose autofill this textbox
            disabled: !this.orderEditable
        };

        this.inputPropsChassisNumber = {
            id: "vehicle__autosuggest__inputPropsChassisNumber",
            placeholder: "minim 3 caractere pentru cautare",
            class: "form-control",
            name: "ChassisNumber",
            autocomplete: "off", // google will not propose autofill this textbox
            disabled: !this.orderEditable
        };
    },

    beforeDestroy() {
        EventBus.$off('owner_selected', this.ownerSelected);
    },

    methods: {
        ...mapMutations({
            setVehicleToOrder: 'order/setVehicle',
            setPersonToOrder: 'order/setPerson',
            setCompanyToOrder: 'order/setCompany',
            setOwnerAddress: 'order/setOwnerAddress',
        }),
        //
        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },
        //
        registerType_changed(value) {
            console.log('registerType_changed');
            this.registerType = value;
            this.vehicle.RegistrationType = value.Code;
        },

        setMultiSelectObjects() {
            this.registerType = this.registerTypes.find(item => item.Code == this.vehicle.RegistrationType);
            this.vehicleCategory = this.vehicleCategories.find(item => item.Code == this.vehicle.Category);

            if (this.vehicleCategory) {
                this.vehicleSubCategories = this.vehicleCategory.SubCategories;
                this.vehicleSubCategory = this.vehicleSubCategories.find(item => item.Code == this.vehicle.SubCategory);
            }
            this.usageType = this.usageTypes.find(item => item.Code == this.vehicle.UsedFor);
            this.fuelType = this.fuelTypes.find(item => item.Code == this.vehicle.FuelType);
            this.vehicleBrand = this.vehicleBrands.find(item => item.Code == this.vehicle.Brand);
            this.buildYear = this.buildYears.find(item => item.Code == this.vehicle.ManufacturingYear);
        },

        vehicleCategory_changed(value) {
            console.log('vehicleCategory_changed');
            this.vehicleCategory = value;
            this.vehicle.Category = value.Code;

            this.vehicleSubCategory = null;
            this.vehicleSubCategories = value.SubCategories;
        },

        vehicleSubCategory_changed(value) {
            console.log('vehicleSubCategory_changed');
            this.vehicleSubCategory = value;
            this.vehicle.SubCategory = value.Code;
        },

        usageType_changed(value) {
            console.log('registerType_changed');
            this.usageType = value;
            this.vehicle.UsedFor = value.Code;
        },

        fuelType_changed(value) {
            console.log('fuelType_changed');
            this.fuelType = value;
            this.vehicle.FuelType = value.Code;
        },

        vehicleBrand_changed(value) {
            console.log('vehicleBrand_changed');
            this.brand = value;
            this.vehicle.Brand = value.Code;
        },

        buildYear_changed(value) {
            console.log('buildYear_changed');
            this.buildYear = value;
            this.vehicle.ManufacturingYear = value.Code;
        },

        // vehicle search
        fetchVehicleSugestionsByPlateNo(val) {

            var model = this;

            //reset timer if new change before timeout
            clearTimeout(this.timeoutObj);

            this.timeoutObj = setTimeout(() => {

                if (val.length > 2) {
                    model.loadingVehicles = true;
                    orderService.getVehicleListByUniqueKey(val, 'PlateNo').then(response => {
                        model.vehicleSuggestions = [];
                        model.vehicleSuggestions.push({ name: "vehicles", data: response.data });

                        model.loadingVehicles = false;
                    })
                }

            }, 600);
        },
        fetchVehicleSugestionsByChassisNumber(val) {

            var model = this;

            //reset timer if new change before timeout
            clearTimeout(this.timeoutObj);

            this.timeoutObj = setTimeout(() => {

                if (val.length > 2) {
                    model.loadingVehicles = true;
                    orderService.getVehicleListByUniqueKey(val, 'ChassisNumber').then(response => {
                        model.vehicleSuggestions = [];
                        model.vehicleSuggestions.push({ name: "vehicles", data: response.data });

                        model.loadingVehicles = false;
                    })
                }

            }, 600);
        },

        getSuggestionValue(suggestion) {
            return suggestion.item.PlateNo;
        },

        getChassisNumberValue(suggestion) {
            return suggestion.item.ChassisNumber;
        },

        ownerSelected: function (id, type) {
            var model = this;
            model.loadingVehicles = true;
            ownerService.getVehicleListForOwner(id, type).then(response => {
                model.ownerVehicles = response.data;
                model.loadingVehicles = false;

                if (model.ownerVehicles.length > 0) {
                    model.$refs['ownerVehiclesModal'].show();
                }
            });
        },
        ownerVehicleSelected: function (item) {

            this.vehicle = item[0];
            this.setMultiSelectObjects();
            this.$refs['ownerVehiclesModal'].hide();
        }
    },

    watch: {
        vehicle: {
            handler: function (val, oldVal) {
                this.setVehicleToOrder(val);
            },
            deep: true,
        },
    },
}
